import React, { Component } from 'react';
import Util from '../utils'

class Main extends Component{
    constructor(props){
        super(props)

        //set all pages
        window.isMain = true
        var self = this
        self.isLoadingFinished = false

        Util.onScroll((e) => {
            console.log(e)
            //after window ready
            //let element = e.srcElement.activeElement

            if(window.isMain){

                let element = (!e) ? window : e.srcElement.defaultView //.scrollY  //scrollBy(), scrollTo(), pageYOffset
                let scrollY = (element.pageYOffset || element.pageYOffset == 0) ? element.pageYOffset : element.scrollTop;
                let sH = window.innerHeight

                let header = document.querySelector('#top-head .navbar');
                let logo = document.querySelector('#logo img')
                let logoText = document.querySelector('#logo-name')
                let logoCopy = document.querySelector('#logo-copy')

                console.log(scrollY, sH)
                if (scrollY < sH) {
                    let toH = sH - scrollY
                    let pct = toH/sH
                    let pctReverse = 1 - pct
                    console.log('pct', pct, pctReverse)
                    if(toH > 22){
                        header.style.height = toH + 50 + 'px'
                        logo.style.width = (70 - 64*pctReverse) + '%'
                        logo.style.height = 'auto'
                        logoText.style.fontSize = (3 - 2.6*pctReverse) +'em'
                        logoCopy.style.fontSize = (1.6 - 1*pctReverse) +'em'
                        logoCopy.style.opacity = pct - .2

                    }else {
                        header.style.height = 'auto'
                        logo.style.width = ''
                        logo.style.height = ''
                        logoText.style.fontSize = ''
                        logoCopy.style.fontSize = ''
                        logoCopy.style.opacity = ''

                    }
                }else {
                    header.style.height = 'auto'
                    logo.style.width = ''
                    logo.style.height = ''
                    logoText.style.fontSize = ''
                    logoCopy.style.fontSize = ''
                    logoCopy.style.opacity = ''
                }

                if (!self.isLoadingFinished) {
                    this.props.setLoadingFinished()
                    self.isLoadingFinished = true
                }
            }

        })
    }

    render(){
        return (
            <div className={'main-con'}>
                <section className="no-1">
                    <h1>Your business card manager</h1>
                </section>
                <section className="no-2">
                    <div className="feature-wrap">
                        <h2>Card & Text detection</h2>
                        <h2>Auto Shot</h2>
                    </div>
                    <img src="../static/img/card-and-text-detection.png" alt="Card and text detection and auto shot"/>
                </section>
                <section className="no-3">
                    <div className="feature-wrap">
                        <h2>Recognizing Information</h2>
                    </div>
                    <img src="../static/img/recognizing-information.png" alt="Recognizing information"/>
                </section>
                <section className="no-4">
                    <div className="feature-wrap">
                        <h2>Quick Search</h2>
                    </div>
                    <img src="../static/img/quick-search.png" alt="Quick search"/>
                </section>
                <section className="no-5">
                    <div className="feature-wrap">
                        <h2>Make a call</h2>
                        <h2>Get direction</h2>
                        <h2>Send email</h2>
                        <h2>Even more</h2>
                    </div>
                    <img src="../static/img/make-a-call-get-direction-send-email.png" alt="Make a call, Get direction, Send email, Even more"/>
                </section>
                <a id="btn-download" href="https://apps.apple.com/us/app/keeper-b/id1440461831?ls=1" target={'_blank'}>
                    <img src="../static/img/badge-download-on-the-app-store.png" alt="download on app store badge"/>
                </a>
            </div>
        )
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/component/main.js